import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    updateEventDetailsById,
    getEventBySlug,
    setEventData
} from '../../../../../../app/store/slices/event/event';
import { getAllSacCodes } from '../../../../../../app/store/slices/gst-rates/gst';
import { errorToast, successToastTopRight } from '../../../../../../utils/toasts/toasts';

export default function useTaxInvoiceInfo() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { user } = useSelector((state) => state.auth);
    const { sacCodes } = useSelector((state) => state.gst);
    const { eventData } = useSelector((state) => state.event);

    useEffect(() => {
        if (user?.verification?.pan_number && sacCodes.length === 0) {
            dispatch(getAllSacCodes());
            // dispatch(getEventBySlug(eventData?.slug));
        }
    }, [user?.verification?.pan_number, dispatch]);

    const initialValues = {
        // sacCode: eventData?.sac_code?.id || "",
        sacCode: sacCodes?.data?.find((sac) => sac.id === eventData?.sac_code_id) || null,
        panNumber: user?.verification?.pan_number || '',
        gstNumber: user?.verification?.gst_number || '',
        address: user?.address || '',
        city: user?.invoice_city_id || '',
        state: user?.state_id || '',
        pincode: user?.pincode || '',
        country: user?.country_id || ''
    };

    // console.log("Initial Values -> ", initialValues);

    const validationSchema = Yup.object({
        sacCode: Yup.object(),
        panNumber: Yup.string(),
        gstNumber: Yup.string(),
        address: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        pincode: Yup.string(),
        country: Yup.string()
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                setLoading(true);

                const payload = {
                    sac_code_id: values.sacCode?.id
                };

                // console.log("Payload -> ", payload);
                await dispatch(
                    updateEventDetailsById({ eventId: eventData?.eventId, eventData: payload })
                ).unwrap();
                // dispatch(
                //     setEventData({
                //         ...eventData, // Keep existing values
                //         sac_code_id: values.sacCode?.id || 1 // Update the SAC code
                //     })
                // );

                await dispatch(getEventBySlug(eventData?.slug)).unwrap();
                successToastTopRight('Tax invoice info updated successfully');

                setLoading(false);
            } catch (error) {
                errorToast(error?.message || 'Failed to update tax invoice info');
            } finally {
                setLoading(false);
            }
        }
    });

    // console.log("Formik values -> ", formik.values);
    // console.log("Formik errors -> ", formik.errors);

    return {
        formik,
        loading
    };
}
